import api, { formatApiErrorDetail, SERVICE_TYPES, normalizeServiceType } from "@/lib/api";
import { toast } from "sonner";
import { format, startOfWeek, addDays } from "date-fns";

export const dateKey = (date) => format(date, "yyyy-MM-dd");
export const weekStart = (date) => startOfWeek(date, { weekStartsOn: 1 });
export const weekEnd = (date) => addDays(weekStart(date), 6);
export const chileToday = () => new Date(new Intl.DateTimeFormat("sv-SE", { timeZone: "America/Santiago" }).format(new Date()) + "T12:00:00");
export const errorMessage = (error) => formatApiErrorDetail(error?.response?.data?.detail || "No se pudo completar la acción. Intenta nuevamente.");
export const typeLabel = (value) => SERVICE_TYPES.find((t) => t.value === normalizeServiceType(value))?.label || "Servicio";
export const STATUS = {
  scheduled: ["Programada", "#ff965e"], in_progress: ["En curso", "#6cb9ff"],
  pending_review: ["Entregada al equipo", "#e7c75c"], completed: ["Realizada", "#64d39a"], cancelled: ["Cancelada", "#a3a3a3"],
};
export const CATEGORIES = { before: "Antes", after: "Después", fault: "Fallas", signed_sheet: "Hoja firmada" };
export const FINDING_STATUS = { to_evaluate: "Por evaluar", quoted: "Cotizado", resolved: "Resuelto" };

export async function downloadCalendar(path, filename) {
  try {
    const { data } = await api.get(path, { responseType: "blob" });
    const url = URL.createObjectURL(data);
    const a = document.createElement("a"); a.href = url; a.download = filename;
    document.body.appendChild(a); a.click(); a.remove(); setTimeout(() => URL.revokeObjectURL(url), 1500);
    toast.success("Archivo .ics descargado para importar en tu calendario");
  } catch (error) {
    let detail;
    try { detail = JSON.parse(await error.response.data.text()).detail; } catch {}
    toast.error(detail || "No se pudo exportar el calendario");
  }
}